module.exports = __webpack_public_path__ + "img/gonetwork2_icon13.54cfeb43.png";